<template>
  <div class="article">
    <bread-crumb></bread-crumb>
    <div class="wrap">
      <iframe class="iframe_article" :src="mUrl" id="iframe" scrolling="yes"></iframe>
      <div class="distribution">
        <div class="c-title-wrap" style="margin-top: 40px"><p class="c-title">审核结果</p></div>
        <div class="content-item flex">
          <p>敏感词</p>
          <span class="distribution-notes">对接主站天网/红盾系统</span>
        </div>
        <div class="content-item flex">
          <p class="distribution-sensitive">{{ res.sensitiveWords ? res.sensitiveWords : '暂无' }}</p>
        </div>
        <div class="content-item flex">
          <p>文章原创度</p>
          <span class="distribution-notes">对接第三方维权骑士</span>
        </div>
        <div class="content-item flex">
          <p class="distribution-sensitive" style="width: auto">
            <span class="black" v-if="articleOriginality">
              文章原创度：
              <span class="red">{{ this.articleOriginality }}%</span></span>
            <span class="black" v-if="originalityCheckTime">
              历史查重时间：{{ this.originalityCheckTime }}</span>
            {{ this.articleOriginalityText || '' }}
          </p>
        </div>
        <article-basic
          :articleSource.sync="res.articleSource"
          :articleLevel.sync="res.articleLevel"
          :articelId.sync="this.$route.query.id"
          :articelRadio.sync="res.contentAttributes"
          :articelDisabled="true"
          :articleIndex="contentIndexes"
          @indexChange="indexChange"
        >
          <reprinted-from
            style="margin-left: 40px"
            v-if="res.articleSource == 2"
            :reprintedFrom.sync="res.reprintedFrom"
            :reprintedDisabled="true"
          >
          </reprinted-from>
        </article-basic>
        <div class="content-item flex" v-if="res.extensionCommonLabelsGroup">
          <p class="distribution-label">文章标签</p>
        </div>
        <span v-if="res.extensionCommonLabelsGroup">
          <div class="content-item flex" v-for="(item,index) in res.extensionCommonLabelsGroup" :key="index">
          <!--标签名称-->
            <el-tooltip class="item" effect="dark" :content="item.name" placement="left">
          <div class="labels-title">{{ item.name }}</div>
            </el-tooltip>
            <div style="width: 90%;">
            <span v-for="(level,i) in item.contentLabels" :key="i">
              <!--一级标签，一级标签下没有二级只显示一级-->
              <el-tooltip
                class="item"
                effect="dark"
                :content="level.name"
                placement="top"
                v-if="!(level.contentLabels && level.contentLabels.length > 0) && level.isChecked"
              >
              <span
                class="distribution-tags"
                v-if="!(level.contentLabels && level.contentLabels.length > 0)  && level.isChecked">{{
                  level.name
                }}</span>
               </el-tooltip>
              <span v-if="level.contentLabels && level.contentLabels.length > 0">
                <span v-for="(levels,l) in level.contentLabels" :key="l">
                  <!--二级标签，有二级标签，显示一级+二级标签-->
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content=" level.name + '/' + levels.name"
                    placement="top"
                    v-if="!(levels.contentLabels && levels.contentLabels.length > 0) && levels.isChecked"
                  >
                  <span
                    class="distribution-tags"
                    v-if="!(levels.contentLabels && levels.contentLabels.length > 0)&& levels.isChecked"
                  >{{ level.name + '/' + levels.name }}
                  </span>
                  </el-tooltip>
                    <span v-if="levels.contentLabels && levels.contentLabels.length > 0">
                      <!--三级标签，有三级标签，显示一级、二级、三级标签-->
                      <span v-for="(leveles,l) in levels.contentLabels" :key="l">
                        <el-tooltip
                          class="item"
                          effect="dark"
                          :content="level.name + '/' + levels.name + '/' + leveles.name"
                          placement="top"
                          v-if="leveles.isChecked"
                        >
                        <span class="distribution-tags"
                              v-if="leveles.isChecked">{{ level.name + '/' + levels.name + '/' + leveles.name }}</span>
                        </el-tooltip>
                     </span>
                  </span>
                </span>
              </span>
             </span>
            </div>
        </div>
        </span>
        <div class="content-item flex" v-if="res.diseaseLabels">
          <p class="distribution-label">疾病标签</p>
        </div>
        <span v-if="res.diseaseLabels">
          <div class="content-item flex">
            <span v-for="(item,index) in res.diseaseLabels" :key="index">
          <div class="distribution-tags">{{ item.diseaseName }}</div>
            </span>
        </div>
        </span>
        <distribution-tag
          :tenantId="this.$route.query.id"
          ref="businessColumnChannel"
          :auxiliaryShow="true"
        ></distribution-tag>
        <active-modal
          :dialogData.sync="tableVal"
          :dialogPreVisible.sync="activeDialogPreVisible"
        ></active-modal>
      </div>
    </div>
    <div class="distribution-button">
      <el-button type="primary" @click="addChannel">添加频道</el-button>
      <el-button @click="copyUrl">复制线上链接</el-button>
    </div>
  </div>
</template>

<script>
import breadCrumb from "../../../../../components/breadCrumb";
import ArticleBasic from "../../../../../components/radio/ArticleBasic";
import DistributionTag from "../../../../../components/tag/DistributionTag";
import {queryContentRiskControl} from "../../../../../api/man";
import ActiveModal from "../../../../../components/pop/AddActiveDialog";
import {generateOnlineDi, addChannel, getArticleByPid} from "../../../../../api/contentDistribution";
import {copyUrl} from "@/utils/tools";
import ReprintedFrom from "../../../../../components/combination/ReprintedFrom";

export default {
  name: "contentDistributionArticle",
  components: {
    ReprintedFrom,
    DistributionTag,
    ArticleBasic,
    breadCrumb,
    ActiveModal,
  },
  data() {
    return {
      sensitiveWords: '',
      isArticleOriginaly: false,
      articleOriginality: "",
      articleOriginalityText: '',
      articleOriginalityCode: '',
      originalityCheckTime: '',
      activeDialogPreVisible: false,
      tableVal: {},
      mUrl: '',
      res: [],
      form: {
        contentBusinesses: [],
        contentChannels: [],
        contentIndexes: []
      },
      contentIndexes: []
    }
  },
  created() {
    this.searchArticleById();
    this.generateOnlineDi();
  },
  mounted() {
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener('popstate', this.cancel, false);
    }
    setTimeout(() => {
      // 添加这段代码
      const $el = document.querySelectorAll('.el-cascader-node[aria-owns]');
      console.log($el);
      Array.from($el).map((item) => item.removeAttribute('aria-owns'));
    }, 300);
  },
  destroyed() {
    window.removeEventListener('popstate', this.cancel, false);
    // 移除段落缓存
    sessionStorage.removeItem('cache_articles')
  },
  methods: {
    cancel: function () {
      if (this.$route.query.distribution == 1) {
        this.$router.push(`/contentDistribution`)
        sessionStorage.setItem('distribution', 1)
      } else {
        this.$router.push(`/businessPage`)
        sessionStorage.setItem('business', 1)
      }
    },
    searchArticleById() {
      return new Promise((resolve, reject) => {
        getArticleByPid({
          articleId: this.$route.query.id,
          tenantId: this.$commonJs.getTenantId()
        }).then(res => {
          this.res = res
          const treeToArrObj = (obj) => {
            if (!obj.contentIndexes || obj.contentIndexes.length === 0) {
              return { indexId: obj.indexId };
            }
            treeToArrObj(obj.contentIndexes[0]);
          }
          const treeToArr = (obj, arr) => {
            if (obj && obj.indexId) {
              arr.push(obj.indexId);
              treeToArr(obj.contentIndexes[0], arr);
            }
            if (!obj || !obj.contentIndexes || obj.contentIndexes.length === 0) {
              return arr;
            }
          }
          if (res?.contentIndexes?.length > 0) {
            const arr = [];
            treeToArr(res.contentIndexes[0], arr)
            console.log(treeToArrObj(res.contentIndexes[0]), arr, 33333);
            this.form.contentIndexes = [treeToArrObj(res.contentIndexes[0])];
            this.contentIndexes = arr;
          }
          this.queryContentRiskControl(res.id, this.$commonJs.getTenantId());
          resolve(this.res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    // 查重接口-------------------------------------
    queryContentRiskControl(contentId, tenantId) {
      queryContentRiskControl({contentId, tenantId}).then((res) => {
        if (res.code) {
          // 传回3300 | 3301 | 3302 | 3303 | 3304时，显示msg文案，若有历史原创度，显示文案+历史原创度
          // axios公共工具函数返回code时，即接口返回code === 3300 | 3301 | 3302 | 3303 | 3304
          this.isArticleOriginaly = false
          this.articleOriginalityText = res.msg;
          this.articleOriginalityCode = res.code;
          if (res.data) {
            this.articleOriginality = res.data.originality + '';
            this.originalityCheckTime = res.data.originalityCheckTime;
          }
        } else { // 与后端协商达成一致，此接口有六种code，传回0000时，只显示原创度
          this.articleOriginality = res.originality + '';
        }
      })
    },
    // 生成线上地址
    generateOnlineDi() {
      generateOnlineDi({
        contentId: this.$route.query.id,
        contentType: this.$route.query.type
      }).then(res => {
        if (res) {
          this.mUrl = res.mUrl
        }
      })
    },
    // 添加频道
    addChannel() {
      this.$refs.businessColumnChannel.getBizListData(this.form);
      addChannel({
        contentIds: this.$route.query.id ? [Number(this.$route.query.id)] : [],
        tenantId: this.$commonJs.getTenantId(),
        contentChannels: this.form.contentChannels,
      }).then(res => {
        if (res) {
          this.$message({
            message: '添加频道成功！',
            type: 'success'
          });
          this.searchArticleById();
          this.queryContentRiskControl();
          // this.$router.go(0)
          setTimeout(()=>{
            this.$refs.businessColumnChannel.getBusiness()
          },2000)
        }
      }).catch(err => {
        this.$message.error(err.msg);
      })
    },
    copyUrl() {
      this.activeDialogPreVisible = true;
      this.tableVal = this.res;
    },
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/css/common/mixin.scss";
@import "@/styles/pages/articleBAK.scss";

.iframe_article {
  position: relative;
  width: 375px;
  height: 751px;
  float: left;
  border-radius: 20px;
  margin-top: 40px;
  margin-right: 50px;
}
.distribution {
  width: 975px;
  display: inline-block;
}

.distribution-notes {
  font-size: 12px;
  font-family: PingFangSC;
  font-weight: normal;
  color: rgba(255, 120, 46, 1);
}

.distribution-sensitive {
  font-size: 14px;
  font-family: PingFangSC;
  font-weight: normal;
  color: rgba(139, 140, 154, 1);
}

.content-item p {
  text-align: left !important;
  padding-left: 30px;
}

.distribution-tags {
  display: inline-block;
  max-width: 251px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  color: #C6C6CA;
  border-radius: 2px;
  border: 1px solid #C6C6CA;
  margin-left: 30px;
  margin-bottom: 10px;
  padding: 0 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.distribution-button {
  position: fixed;
  text-align: center;
  width: 86%;
  background-color: #FFFFFF;
  bottom: 0;
}

.content-item {
  min-width: auto !important;
}

.distribution-label {
  font-weight: 700;
}

.labels-item {
  display: flex;
  flex-flow: wrap;
}

.labels-title {
  margin-left: 30px;
  line-height: 32px;
  width: 10%;
  max-height: 32px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
